import { render, staticRenderFns } from "./DcIcon.vue?vue&type=template&id=39959eda&scoped=true&"
import script from "./DcIcon.vue?vue&type=script&lang=js&"
export * from "./DcIcon.vue?vue&type=script&lang=js&"
import style0 from "./DcIcon.vue?vue&type=style&index=0&id=39959eda&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39959eda",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/frontend/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39959eda')) {
      api.createRecord('39959eda', component.options)
    } else {
      api.reload('39959eda', component.options)
    }
    module.hot.accept("./DcIcon.vue?vue&type=template&id=39959eda&scoped=true&", function () {
      api.rerender('39959eda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "@lab/components/dcicon/DcIcon.vue"
export default component.exports